import { ParchiPatient } from "@elixir/types";
import { GET_PARCHI_HOST } from "../constants/env";

type ParchiPatientResponse = {
  currentPageMeta: {
    currPageNo: number;
    pageSize: number;
    totalRecords: number;
    totalPages: number;
    nextPage: number;
  };
  data: Array<ParchiPatient>;
  status: "success" | "error";
  version: number;
};

export default async function getPatientByPid({
  patientOid,
}: {
  patientOid: string;
}): Promise<ParchiPatientResponse> {
  try {
    const PARCHI_HOST = GET_PARCHI_HOST();
    let endpoint = `${PARCHI_HOST}/app/get/my/patients?pid=${patientOid}&flavour=dw`;
    const response = await fetch(endpoint, {
      method: "GET",
      redirect: "follow",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.json();
  } catch (error) {
    return {
      status: "error",
    } as ParchiPatientResponse;
  }
}
